import { gql, TypedDocumentNode } from "@apollo/client";

import { GithubIntegration } from "types/generated";

type GetGitHubIntegrationData = {
  githubIntegration: Pick<GithubIntegration, "vcsChecks" | "useGitCheckout">;
};
export const GET_GITHUB_INTEGRATION: TypedDocumentNode<GetGitHubIntegrationData> = gql`
  query GetGitHubIntegration {
    githubIntegration {
      vcsChecks
      useGitCheckout
    }
  }
`;
